import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Price, was-price, price-mode checkboxes, per-size price deltas, and shipping rate selector.
export const PricingSection = ({ isNew, config, form, optionalShippingRates, shippingRates, handleField, updateSize }) => (
  <>
    <div className="grid grid-cols-2 gap-4">
      <label className="block">
        <span className={LABEL_CLASS}>Price (NZD)</span>
        <input data-testid="admin-field-price" type="number" step="0.01" value={form.price} onChange={(e) => handleField("price", e.target.value)} className={FIELD_CLASS} disabled={form.priceOnRequest} />
        {form.priceOnRequest && (
          <span data-testid="admin-field-price-disabled-hint" className="block text-xs text-white/40 mt-1">
            Uncheck "Price on request" below to set a price.
          </span>
        )}
      </label>
      {config.hasPriceWas && (
        <label className="block">
          <span className={LABEL_CLASS}>Was Price (for clearance/sale strike-through, optional)</span>
          <input data-testid="admin-field-price-was" type="number" step="0.01" value={form.priceWas} onChange={(e) => handleField("priceWas", e.target.value)} className={FIELD_CLASS} />
        </label>
      )}
    </div>
    <div className="flex gap-6">
      <label className="flex items-center gap-2 text-white/80 text-sm">
        <input data-testid="admin-field-price-from" type="checkbox" checked={form.priceFrom} onChange={(e) => handleField("priceFrom", e.target.checked)} />
        Price is "From" (starting price)
      </label>
      <label className="flex items-center gap-2 text-white/80 text-sm">
        <input data-testid="admin-field-price-on-request" type="checkbox" checked={form.priceOnRequest} onChange={(e) => handleField("priceOnRequest", e.target.checked)} />
        Price on request (Enquire only)
      </label>
    </div>
    {!isNew && config.hasSizes && form.sizes.length > 1 && (
      <div className="flex flex-wrap items-center gap-4 -mt-1">
        {form.sizes.slice(1).map((size, i) => {
          const si = i + 1;
          return (
            <label key={si} className="flex items-center gap-2 text-sm">
              <span className="text-white/60 whitespace-nowrap">
                {size.label || `Size ${si + 1}`} is +$
              </span>
              <input
                data-testid={`admin-size-price-${si}`}
                type="number"
                step="0.01"
                value={size.priceDelta}
                onChange={(e) => updateSize(si, "priceDelta", Number(e.target.value))}
                className={FIELD_CLASS + " mt-0 !w-24 flex-none"}
                placeholder="0"
              />
              <span className="text-white/40 text-xs whitespace-nowrap">
                more than {form.sizes[0].label || "the base size"} (sells at ${(Number(form.price || 0) + Number(size.priceDelta || 0)).toLocaleString("en-NZ")})
              </span>
            </label>
          );
        })}
      </div>
    )}
    <label className="block">
      <span className={LABEL_CLASS}>Shipping Rate</span>
      <select
        data-testid="admin-field-shipping-rate"
        value={form.shippingRateId}
        onChange={(e) => handleField("shippingRateId", e.target.value)}
        className={FIELD_CLASS}
      >
        <option value="">
          {shippingRates.find((r) => r.isDefault) ? `Default ($${(shippingRates.find((r) => r.isDefault).priceCents / 100).toFixed(2)})` : "Default"}
        </option>
        {optionalShippingRates.map((r) => (
          <option key={r.id} value={r.id}>{r.name} (${(r.priceCents / 100).toFixed(2)})</option>
        ))}
      </select>
    </label>
  </>
);
